module.exports = __webpack_public_path__ + "static/social-image-generic-b8c4738344f2cee3c7ff9c3e23961377.png";